module.exports = __webpack_public_path__ + "img/fuck-off.163507f7.jpg";